import { render, staticRenderFns } from "./abandon-task-dialog.vue?vue&type=template&id=30b00dbb&"
import script from "./abandon-task-dialog.vue?vue&type=script&lang=js&"
export * from "./abandon-task-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports